import React from "react";
import "./index.css";

function Footer() {
  return (
    <div className="footer">
      <p>
        Created by:  <a href="https://github.com/gazanfarli"> Gazanfarli Gazanfarli </a> 
        using
        <a href="https://github.com/r-spacex/SpaceX-API"> SpaceX API </a>
      </p>
    </div>
  );
}

export default Footer;
